// extracted by mini-css-extract-plugin
module.exports = {"editor":"TermsCreateModal_editor__hsq9C"};